import React, { useEffect, useState } from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { GetBaseUrl } from "./getBaseUrl";
import { useDispatch, useSelector } from "react-redux";
import { addTokenInfo, doLogout } from "../LoginPage/redux/actions";
import avatar from "../../Assets/svg/avatar-img.svg";
import { useNavigate } from "react-router-dom";
import { api } from "../../Services";
import { addMentorInfo, resetClear } from "../Connect/redux/actions";
import { resetState } from "../PersonalInfo/redux/actions";
import { resetIncome } from "../IncomeDetails/redux/actions";
import { resetEdu } from "../Education/redux/actions";
import { resetRegister } from "../Register/redux/actions";
import { resetApp, showNotified } from "../ApplicationForm/redux/actions";
import { resetQueries } from "../Queries/redux/actions";
import { resetStatus } from "../WelcomeBack/redux/actions";
import { clearDisburse } from "../DisburseForm/redux/actions";
import { GetLogout } from "./Logout";

export default function AccountMenu(props) {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const tokenData = useSelector((state) => state.tokens.tokens);
  const personalInfo = useSelector((state) => state.personal.personalInfo);
  const notifications = useSelector((state) => state.connect.notifications);
  const [options, setOptions] = useState([]);
  const dispatch = useDispatch();
  const open = Boolean(anchorEl);

  const handleClose = () => {
    setAnchorEl(null);
  };
  const getLogout = async () => {
    // const personalInfo = useSelector((state) => state.personal.personalInfo);
    // const dispatch = useDispatch();
    // const tokenData = useSelector((state) => state.tokens.tokens);

    try {
      let users = await api.logout(tokenData.token, personalInfo?.mobile);
      console.log("logout api", users);
      // if (users.statusCode == 200) {
      dispatch(resetState());
      dispatch(resetIncome());
      dispatch(resetEdu());
      dispatch(resetRegister());
      dispatch(resetApp());
      dispatch(resetQueries());
      dispatch(resetStatus());
      dispatch(clearDisburse());
      dispatch(resetClear());
      dispatch(doLogout());
      // }
      // return users;
    } catch (error) {
      console.error("Error logging out:", error);

      //   } finally {
      // setIsLoading(false);
    }
  };

  const logoutMsg = async () => {
    // let users=await getLogout();
    let users = await getLogout();
    console.log("logout api", users);
  };
  const raiseField = (type) => {
    let url = GetBaseUrl(window.location.href);
    console.log("type in menu", type);
    if (props.id !== "bell-menu") {
      if (type === "home") {
        if (tokenData.applicationStatus === "Registered") {
          navigate("/application/status");
        }
        // else {
        //   navigate("/application/submitted-status");
        // }
        // window.location.replace(url + "/application");
        // }
      } else if (type === "application") {
        navigate("/application/form");
        // window.location.replace(url + "/application");
        // }
      } else if (type === "profile") {
        navigate("/application/alumni/user-profile");
        // window.location.replace(url + "/application");
        // }
      } else if (type === "queries") {
        // window.location.replace(url + "/application/help/view-queries");
        navigate("/application/help/view-queries");
      } else if (type === "disburse") {
        // window.location.replace(url + "/application/disburse-form");
        navigate("/application/disburse-review");
      } else if (type === "logout") {
        // dispatch(doLogout());
        logoutMsg();

        // window.location.replace(url);
        // navigate("/");
      } else if (!props.isLogin) {
        // window.location.replace(url + "/application/help");
        navigate("/application/help");
      } else {
        navigate(url + "/help");
        // window.location.replace(url + "/help");
      }
    }
  };

  function getCurrentFormattedDate() {
    const now = new Date();
    const isoString = now.toISOString(); // Example: "2024-07-04T12:43:23.123Z"

    // Remove the milliseconds and 'Z' at the end of the string
    const formattedDate = isoString.split(".")[0];

    return formattedDate;
  }

  const getNotifications = async () => {
    try {
      const notifyData = await api.getNotifications(
        tokenData.token,
        tokenData.applicationData.id
      );

      if (notifyData.statusCode == 200) {
        let data = notifyData.data
          ? [
              ...notifyData.data?.sort((a, b) => a?.id - b?.id).reverse(),
            ]?.slice(0, 10)
          : [];
        if (notifications !== data) {
          dispatch(showNotified(true));
        }
        dispatch(addMentorInfo({ type: "notifications", value: data }));
      }
      // if (mentorData.data) {
      //   dispatch(addMentorInfo([...mentorData.data]));
      // }
      console.log("notifyData", notifyData);
    } catch (err) {
      console.log("err", err);
    }
  };
  const makeRequest = async (item) => {
    // console.log("in checkModified after timer");
    // let noNullData=replaceNullsWithEmptyStrings(cleanObjectStrings(CombineData()))
    if (item.type === "Dropout") {
      dispatch(addTokenInfo(["isDropout", true]));
      dispatch(addTokenInfo(["showDropout", true]));
      navigate("/application/submitted-status");
    }
    let data = [
      {
        id: item?.id,
        message: item?.message,
        viewed: true,
        viewedDateTime: getCurrentFormattedDate(),
        updatedDateTime: getCurrentFormattedDate(),
        userId: item?.userId,
        type: item?.type,
        url: item?.url,
      },
    ];

    try {
      const request = await api.updateNotifications(
        tokenData.token,
        data,
        tokenData.applicationData.id
      );
      console.log("users", request);
      // return request;
      if (request.statusCode == 200) {
        getNotifications();
      }
    } catch (error) {
      console.error("Error invoking Aadhaar OTP:", error);
      // Handle error scenario
    }
    // setModified(false);
    // }
  };

  const ParagraphWithLink = ({ text, url }) => {
    // const link = 'https://www.idfcfirstbank.com/privacy-policy';

    const processText = (text) => {
      // Regular expression to find "here." at the end of the paragraph
      const regex = /here\.$/;
      if (regex.test(text)) {
        // Replace "here." with the link
        const parts = text.split("here.");
        return (
          <>
            {parts[0]}
            <a href={url}>here</a>.
          </>
        );
      }
      return text;
    };

    return <div className="notifications-top">{processText(text)}</div>;
  };
  const setOptionsData = () => {
    let newOptions = [];
    if (props.id === "bell-menu") {
      newOptions = props?.options?.map((obj) => {
        if (obj?.type === "Impact") {
          return { ...obj, message: obj?.message + " here." };
        }
        return obj;
      });
    } else {
      if(props?.options){

        newOptions = [...props?.options];
      }
    }
    setOptions([...newOptions]);
  };

  useEffect(() => {
    setAnchorEl(props.menuEvent);
  }, [props.menuEvent]);

  useEffect(() => {
    setOptionsData();
  }, []);

  useEffect(() => {
    setOptionsData();
  }, [props?.options]);
  
  return (
    <React.Fragment>
      <Menu
        anchorEl={anchorEl}
        id={` lock-menu ${props?.id}`}
        open={open}
        className={`${props?.id ?? "tail"} ${
          props.isSmall ? "mobile-version" : "desk-version"
        }`}
        onClose={handleClose}
        onClick={handleClose}
        MenuListProps={{
          "aria-labelledby": "lock-button",
          role: "listbox",
        }}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
            mt: 1.5,
            "& .MuiAvatar-root": {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            "&::before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        {props.children}
        {options?.map((item, index) => (
          <MenuItem key={index} onClick={() => raiseField(item?.name)}>
            {props.id === "bell-menu" ? (
              <div className="notifications" onClick={() => makeRequest(item)}>
                {/* <div className="notifications-left">
                  <img src={avatar} alt="avatar" />
                </div> */}
                <div className="notifications-right">
                  {/* {
                    item?.type === 'Webinar'? */}
                  <ParagraphWithLink text={item?.message} url={item?.url} />
                  {/* :<div className="notifications-top">{item?.message}</div>} */}

                  {/* <div className="notifications-btm">May 21, 2024</div> */}
                </div>
                <div
                  className="notify-dot"
                  style={{
                    background: "#9B1E26",
                    width: "2%",
                    height: "10%",
                    borderRadius: "36px",
                    display: "flex",
                    alignSelf: "center",
                  }}
                ></div>
              </div>
            ) : (
              item?.title
            )}
          </MenuItem>
        ))}
        {/* <MenuItem> */}
        {/* </MenuItem> */}
        {/* <MenuItem onClick={()=>raiseField('logout')}>
          <Avatar /> Logout
        </MenuItem> */}
      </Menu>
    </React.Fragment>
  );
}
